let OrderableRow = function (props) {
  let dragStart = function (evt) {
    if (["INPUT", "TEXTAREA"].includes(evt.target.nodeName)) {
      return;
    }

    evt.dataTransfer.effectAllowed = "move";
    evt.dataTransfer.setData("text/plain", "Whee");
  };

  let dragEnter = function (evt) {
    if (evt.dataTransfer.effectAllowed === "move") {
      evt.preventDefault();
      props.onOver();
    }
  };

  let dragOver = function (evt) {
    if (evt.dataTransfer.effectAllowed === "move") {
      evt.preventDefault();
    }
  };

  let drop = function (evt) {
    if (evt.dataTransfer.effectAllowed === "move") {
      evt.preventDefault();
      props.onDrop();
    }
  };

  return (
    <div
      className="mc-orderable-item"
      data-dragging={props.dragging}
      data-targeted={props.targeted}
      draggable={props.dragging || null}
      onDragStart={dragStart}
      onDragEnter={dragEnter}
      onDragOver={dragOver}
      onDragEnd={props.onRelease}
      onDrop={drop}>
        <div className="mc-orderable-handle"
          onMouseDown={props.onPick}
          onMouseUp={props.onRelease}/>
        <div className="mc-orderable-content">
          {props.children}
        </div>
    </div>
  );
};

class Orderable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dragIdx: null,
      overIdx: null
    };
  }

  pick(idx) {
    this.setState({
      dragIdx: idx
    });
  }

  over(idx) {
    this.setState({
      overIdx: idx
    });
  }

  release(idx) {
    this.setState({
      dragIdx: null,
      overIdx: null
    });
  }

  drop(idx) {
    let children = this.props.children;
    let a = this.state.dragIdx;
    let b = idx;
    let c = [];
    let d = [];

    if (a !== b) {
      for (let i = 0, j = React.Children.count(children); i < j; i++) {
        c.push(i);
        d.push(children[i].props.orderId);
      }

      c.splice(a, 1);
      c.splice(b, 0, a);

      this.props.onOrder(c.map((i) => d[i]));
    }

    this.release(idx);
  }

  render() {
    let i = 0;

    let rows = React.Children.map(this.props.children, function (child) {
      let idx = i++;
      let dragging = idx === this.state.dragIdx;
      let targeted = idx === this.state.overIdx && !dragging;

      if (targeted) {
        // "before", "after" or false
        targeted = this.state.dragIdx > this.state.overIdx ? "before" : "after";
      }

      return (
        <OrderableRow
          key={child.props.orderId}
          dragging={dragging}
          targeted={targeted}
          onPick={this.pick.bind(this, idx)}
          onOver={this.over.bind(this, idx)}
          onRelease={this.release.bind(this, idx)}
          onDrop={this.drop.bind(this, idx)}>
            {child}
        </OrderableRow>
      );
    }, this);

    return (
      <div className="mc-orderable">
        {rows}
      </div>
    );
  }
}

module.exports = Orderable;